export default function trueApiURL(uri) {
  const configuracion = window.QUALITAS_CONFIG;
  if (!configuracion || typeof configuracion.apiUrl !== 'string'
      || !/^https?:\/\//.test(configuracion.apiUrl.trim())) {
    throw new Error('Configura QUALITAS_CONFIG.apiUrl en /runtime-config.js con la URL de la API');
  }

  const urlApi = configuracion.apiUrl.trim();
  let finUrl = urlApi.length;
  while (urlApi.charAt(finUrl - 1) === '/') {
    finUrl -= 1;
  }
  return `${urlApi.slice(0, finUrl)}/${uri.replace(/^\/+/, '')}`;
}
